/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TransactionSummary { 
    createdDate?: string;
    locationCode?: string | null;
    totalTransactions?: number;
    totalAmount?: number;
    totalRate?: number;
    totalServiceFee?: number;
    totalTax?: number;
    totalDiscount?: number;
    cardCount?: number;
    gPayCount?: number;
    applePayCount?: number;
    cardTotal?: number;
    gPayTotal?: number;
    applePayTotal?: number;
    salesCount?: number;
    refundCount?: number;
    salesTotal?: number;
    refundTotal?: number;
    rowType?: string | null;
}

